$(document).ready(function() {
  
    $('ul.tabs').each(function(){
      var active, content, links = $(this).find('a');
      active = links.first().addClass('active');
      content = $(active.attr('href'));
      links.not(':first').each(function () {
        $($(this).attr('href')).hide();
      });
      $(this).find('a').click(function(e){
        active.removeClass('active');
        content.hide();
        active = $(this);
        content = $($(this).attr('href'));
        active.addClass('active');
        content.show();
        return false;
      });
    });

    if ( typeof price_disabled !== 'undefined' && price_disabled  ) {

        $( '.product .price__container .price-item' ).hide();

    }

    $( '.product .product-form__input select' ).on('change', function() {
      
        var item_check = $( this ).find( 'option:selected' ).data( 'variant-id' );
        if ( item_check ) {
             window.location.href = window.location.origin + window.location.pathname + '?variant=' + item_check;
        }
       
    });
  
  });